import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface GuestRouteProps {
  children: React.ReactNode;
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem('userLoginData');

  useEffect(() => {
    if (isAuthenticated) {
      navigate(-1);
      // navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);
  return !isAuthenticated ? <>{children}</> : null;
};
export default GuestRoute;
